module.exports = __webpack_public_path__ + "static/img/uploadImg.f0729d44.png";